import React, { useEffect, useState } from 'react'
import { StyledSkillSearchLinks } from './styled'
import { API } from 'javascripts/api'
import { MasterSkill } from 'javascripts/api/generated'

const getMasterSkills = async () => {
  const response = await API.apiV1UsersTopJobOfferSearchMasterSkillsGet()

  return response.data
}

export const SkillSearchLinks: React.FC = () => {
  const [masterSkills, setMasterSkills] = useState<MasterSkill[]>([])

  useEffect(() => {
    getMasterSkills().then((skills) => {1
      setMasterSkills(skills as MasterSkill[])
    }).catch(() => {
      setMasterSkills([])
    })
  }, [])

  return <StyledSkillSearchLinks masterSkills={masterSkills} />
}
